import {watch} from 'store/effects';

//store state in localStorage every time it changes
export function* sessionLocalStorage() {
  yield watch(state => state, function* (state) {
    window.localStorage.setItem('store', JSON.stringify(state));
  });
}
